import { Carousel } from '@intigral/domain/lib/core/entities/ScreenEntities';
import { QueryClient } from '@tanstack/react-query';

export const TA_CONTINUE_WATCHING_TYPES = ['CONTINUE_WATCHING_TA_LANDSCAPE', 'WATCH_NEXT_LANDSCAPE'] as const;

export type TaContinueWatchingType = (typeof TA_CONTINUE_WATCHING_TYPES)[number];

export const TA_CONTINUE_WATCHING_QUERY_SEGMENT = 'continue-watching';

export const getCarouselComponentType = (carousel: Carousel): string => carousel.wcpType || carousel.type || '';

export const isContinueWatchingCarousel = (carousel: Carousel): boolean =>
    TA_CONTINUE_WATCHING_TYPES.includes(getCarouselComponentType(carousel) as TaContinueWatchingType);

export const taFeedQueryKeys = {
    all: ['taFeed'] as const,
    continueWatching: () => ['taFeed', TA_CONTINUE_WATCHING_QUERY_SEGMENT] as const,
    carousel: (carousel: Carousel, locationSearch: string) => {
        const segment = isContinueWatchingCarousel(carousel)
            ? TA_CONTINUE_WATCHING_QUERY_SEGMENT
            : getCarouselComponentType(carousel);

        return ['taFeed', segment, carousel.id, carousel.dataSources?.[0], locationSearch] as const;
    },
};

export const isTaContinueWatchingQuery = (queryKey: readonly unknown[]): boolean =>
    queryKey[0] === 'taFeed' && queryKey[1] === TA_CONTINUE_WATCHING_QUERY_SEGMENT;

export const invalidateTaContinueWatchingFeeds = (queryClient: QueryClient) => {
    queryClient.invalidateQueries({
        queryKey: taFeedQueryKeys.continueWatching(),
    });
    queryClient.refetchQueries({
        queryKey: taFeedQueryKeys.continueWatching(),
        type: 'active',
    });
};
